var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"carousel"},[_c('transition',{attrs:{"name":"fade"}},[_vm._l((_vm.imgs),function(img,i){return [(_vm.active === i)?_c('div',{key:`cimg-${i}`,style:({ backgroundImage: `url(${img})` })}):_vm._e()]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }